import Pagination from 'react-bootstrap/Pagination';
import styles from './index.module.scss';
import ItemsPerPageSelector from '../../atoms/ItemsPerPageSelector';

const PaginationTable = ({
  totalPages,
  currentPage,
  onPageChange,
  quantityItemsPerPage,
  setQuantityItemsPerPage,
  labelQuantityItemsPerPage,
}) => {
  const paginate = (pageNumber) => {
    setTimeout(() => {
      onPageChange(pageNumber);
    }, 300);
  };
  return (
    <div className={styles.PaginationBox}>
      <Pagination>
        <Pagination.Prev
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
        />
        <div
          className={
            totalPages > 5 ? styles.paginationMax : styles.paginationMax
          }
        >
          <Pagination.Item
            onClick={() => paginate(1)}
            active={currentPage === 1}
          >
            1
          </Pagination.Item>
          {totalPages > 1 && (
            <>
              {totalPages > 2 && (
                <Pagination.Item
                  onClick={() => paginate(2)}
                  active={currentPage === 2}
                >
                  2
                </Pagination.Item>
              )}

              {(totalPages == 5 || (totalPages > 5 && currentPage === 3)) && (
                <Pagination.Item
                  onClick={() => paginate(3)}
                  active={currentPage === 3}
                >
                  3
                </Pagination.Item>
              )}

              {totalPages > 5 && currentPage > 3 && <Pagination.Ellipsis />}

              {currentPage > 3 && currentPage < totalPages - 1 && (
                <Pagination.Item active>{currentPage}</Pagination.Item>
              )}

              {totalPages > 5 && currentPage < totalPages - 2 && (
                <Pagination.Ellipsis />
              )}

              {totalPages > 3 && (
                <Pagination.Item
                  onClick={() => paginate(totalPages - 1)}
                  active={currentPage === totalPages - 1}
                >
                  {totalPages - 1}
                </Pagination.Item>
              )}
              {totalPages > 1 && (
                <Pagination.Item
                  onClick={() => paginate(totalPages)}
                  active={currentPage === totalPages}
                >
                  {totalPages}
                </Pagination.Item>
              )}
            </>
          )}
        </div>
        <Pagination.Next
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
        />
      </Pagination>

      <ItemsPerPageSelector
        label={labelQuantityItemsPerPage}
        quantityItemsPerPage={quantityItemsPerPage}
        setQuantityItemsPerPage={setQuantityItemsPerPage}
      />
    </div>
  );
};

export default PaginationTable;
